<template>
  <label class="a-radio" :class="[focused ? 'a-radio-focused' : '']">
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="isChecked"
      @change="(e) => handleChange(e)"
      role="button"
      ref="inputRadioRef"
    />
    <div class="a-radio__mark">
      <span class="dot"></span>
    </div>
    <slot></slot>
  </label>
</template>

<script setup>
// eslint-disable-next-line
import { computed, defineEmits, onMounted, ref } from 'vue';

const inputRadioRef = ref({});
const focused = ref(false);
const props = defineProps({
  modelValue: [String, Number],
  value: {
    type: [String, Number],
    description: 'value of radio',
  },
  name: String,
});

const isChecked = computed(() => props.modelValue === props.value);
const emit = defineEmits(['update:modelValue']);
const handleChange = ($event) => {
  let { value } = $event.target;
  if (typeof props.modelValue === 'number') {
    value = +value;
  }
  emit('update:modelValue', value);
};

onMounted(() => {
  window.addEventListener('keyup', (e) => {
    if (document.activeElement === inputRadioRef.value) {
      focused.value = true;
    } else {
      focused.value = false;
    }
  });
});
</script>
